const ChatBot = require("./bot.js");
const { isDev } = require("./config.js");
const { cELM, getParameterByName, debounce, getChatURL, goToKiosk } = require("./utils.js");

let _SOCKET = null;
var progressBar = 0;
var progressBarTimer;
var TIMEOUT = 90000; //90 sec timeout for end of kiosk chat
const SCHEDULERTIMEOUT = 900; // Self Scheduler timeout, will be calculated as 15 minutes
let shouldRedirect = false;

if (location.href.endsWith("mock")) {
  _SOCKET = require("./api-mock.js");
  _SOCKET.initiate();
} else if (location.href.endsWith("mock-search")) {
  _SOCKET = require("./api-mock-search.js");
  _SOCKET.initiate();
} else {
  _SOCKET = require("./socket.js");
}

const _BOT = new ChatBot();
document.getElementById("app-root").addELM(_BOT)

// handle events from the socket
_SOCKET.on("MESSAGE", function(msg_package) {
  if (isDev) {
    console.log("message from server:", msg_package);
  }

  removePendingStates();
  handleEditBtn(msg_package);
  handleEnd(msg_package);
  if (!shouldRedirect) {
    _BOT.handle("onmessage", msg_package);
  }
});

_SOCKET.on("IS_ALIVE", function(msg_package) {
  _SOCKET.emit(
      "IS_ALIVE",
      {
      },
    );
});

_SOCKET.on("UPDATES", function(msg_package) {
  if (isDev) {
    console.log("message from server:", msg_package);
  }

  _BOT.handle("update", msg_package);
});

if (process.env.MOBILE_APP || isDev) {
  _SOCKET.on('METAHTML', function (metaHtml) {
    if (metaHtml.styles) {
      for (const stl of metaHtml.styles) {
        const stylTag = document.createElement("link");
        stylTag.href = stl;
        stylTag.type = "text/css";
        stylTag.rel = "stylesheet";
        document.body.appendChild(stylTag);
      }
    }

    if (metaHtml.js) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.text = metaHtml.js;
      document.body.appendChild(script);
    }
  });
}

function removePendingStates() {
  let items = document.getElementsByClassName("pending-state");
  for (let item of items) {
    item.classList.remove("pending-state");
  }
}

const paramNameFrom = getParameterByName("from");
let isFromKiosk, isFromScheduler;
let selfScheduleQuestionnaire;
switch (paramNameFrom) {
  case 'kiosk':
    isFromKiosk = true;
    break;
  case 'scheduler':
    isFromScheduler = true;
    selfScheduleQuestionnaire = document.getElementById("questionnaire");
    break;
  default:
    break;
}


let lastActiveTime = new Date();
let endChat = false;

if (isFromKiosk) {
  const el = cELM("div", "header-wrapper");

  getDom("body.app").addELM(el);
  getDom("body.app").classList.add('kiosk');

  detectTimeout();
} else if (isFromScheduler) {
  const schedulerHeader = cELM("div", "scheduler-header", '');

  getDom("html").addELM(schedulerHeader);
  getDom("body.app").classList.add('scheduler-extra');

  detectTimeout();
}

function detectTimeout() {
  window.onclick = debounce(function() {
    lastActiveTime = new Date();
  }, 100);
  window.onmousemove = debounce(function() {
    lastActiveTime = new Date();
  }, 200);
  window.onkeypress = debounce(function() {
    lastActiveTime = new Date();
  }, 100);
  window.onscroll = debounce(function() {
    lastActiveTime = new Date();
  }, 100);

  window.setInterval(checkIdleTime, 5000);
}

function checkIdleTime() {
  const dateNowTime = new Date().getTime();
  const latt = new Date(lastActiveTime).getTime();
  const remTime = Math.floor((dateNowTime - latt) / 1000);

  if (isFromScheduler && selfScheduleQuestionnaire) {
    if (remTime >= SCHEDULERTIMEOUT) {
      lastActiveTime = new Date();

      _SOCKET.emit(
      "MESSAGE",
      {
        id: `${selfScheduleQuestionnaire.value.slice(0, -1)}1/answer`,
        value: {
          id: `${selfScheduleQuestionnaire.value.slice(0, -1)}1/answer`,
          data: "Continue",
        },
        action: "startEdit",
        secondaryAction: "lockout"
      });
    }
  } else if (remTime >= 180) {
    lastActiveTime = new Date();
    goToKiosk();
  }
}

function handleEditBtn(packet){
  if((packet.format === "wait") || (packet.format === "end")){
    let items = document.getElementsByClassName("edit");
    for (let item of items) {
      item.classList.remove("edit-active");
    }
  }
}

function handleEnd(packet) {
  if (isFromKiosk && (packet.dataFormat || '').indexOf("yes/no-back") > -1) {
     endChat = true;
  } else if (isFromKiosk && packet.format && packet.format != "end") {
     endChat = false;
  }
  if (isFromKiosk && (packet.format == "end" || (packet.format || '').indexOf("module_creditcard") > -1)) {
    setTimeout(() => {
      if (endChat && progressBarTimer) {
        clearInterval(progressBarTimer)
        var bar = getDom('.bar')
        bar.style.width = '100%'
      }
      goToKiosk({ uid: getChatURL() });
      endChat = false
    }, 1000);
  } else if (isFromKiosk && packet.format == 'wait') {
    startProgressBar()
    setTimeout(()=> {
      if (progressBarTimer)
          clearInterval(progressBarTimer)
      goToKiosk({ uid: getChatURL() });
    }, TIMEOUT)
  } else if (packet.redirectTo) {
    location.href = packet.redirectTo;
    shouldRedirect = true;
  }
}

function startProgressBar(time) {
   var interval = 100
   //console.log('start progress')
   progressBarTimer = setInterval(() => {
      progressBar += 100*interval/TIMEOUT
      var bar = getDom('.bar')
      if (bar)
         bar.style.width = progressBar+'%'
   }, interval)
}

export default {
  // send an text answer
  send: function(data, callback, elm) {

    if(data.id && data.text){
      _SOCKET.emit(
        "MESSAGE",
        {
          answer: data.text,
          id: data.id,
          answerKey: data.answerKey
        },
        callback,
      );

    }
    else
    {
      _SOCKET.emit(
        "MESSAGE",
        {
          answer: data,
          id:data.id
        },
        callback,
      );
    }


    if(data && (data.files || data.file)){
      //allow aborting
    }
    else if (elm) {
      elm.classList.add("pending-state");
    } else {
      // console.error("missing implementation of pending state");
      // console.error(new Error().stack);
    }
  },
  // initial an edit of a question
  edit: function(data, callback) {
    _SOCKET.emit(
      "MESSAGE",
      {
        id: data.id,
        value: {
          id: data.id,
          data: data.text,
        },
        action: "startEdit",
      },
      callback,
    );
  },
  // send object to update
  update: function(data, callback) {
    _SOCKET.emit(
      "MESSAGE",
      {
        answer: data,
        id: data.id
      },
      callback,
    );
  },
  // AB: Edit functionaly with additional actions taken in apisocket.js server
  customEdit: function(data, secondaryAction) {
    _SOCKET.emit(
      "MESSAGE",
      {
        id: data.id,
        value: {
          id: data.id,
          data: data.text,
        },
        action: "startEdit",
        secondaryAction
      },
    );
  },
  BOT: _BOT,
};
